import * as React from 'react';
import { connect } from 'react-redux';
import { ContentWrapper, ContentContainer, CloseButton } from '../style.css';
import Store from '../../../common/models/Store';
import { setNewsletterDisplayedSessionCookie } from '../../../helpers/cookie';
import SignUpView from './SignUpView';
import SuccessView from './SuccessView';
import Lightbox from '../Lightbox';
import { Desktop, Mobile } from '../../MediaQuery';

/* Interfaces */
interface NewsletterLightboxProps {
  basePathWeb: string;
  close: () => void;
  s3BasePath: string;
}

interface NewsletterLightboxState {
  currentViewName: string;
}

interface NewsletterLightboxContentProps {
  border?: string;
  close: () => void;
  contentBackground?: string;
  contentHeight?: string;
  contentWidth?: string;
  currentViewName: string;
  onSubmitSuccess: () => void;
  wrapperBackground?: string;
  wrapperHeight?: string;
  wrapperWidth?: string;
}

/* Helpers */
const mapStateToProps = ({ api: { basePathWeb, s3BasePath } }: Store) => ({
  basePathWeb,
  s3BasePath
});

const viewNames = {
  signUp: 'signUp',
  success: 'success'
};
const viewComponents: { [viewName: string]: React.ComponentType } = {
  [viewNames.signUp]: SignUpView,
  [viewNames.success]: SuccessView
};

/* Components */
class NewsletterLightboxContent extends React.Component<NewsletterLightboxContentProps> {
  render() {
    const {
      onSubmitSuccess,
      close,
      currentViewName,
      wrapperHeight,
      wrapperWidth,
      wrapperBackground,
      contentHeight,
      contentWidth,
      contentBackground,
      border
    } = this.props;

    return (
      <Lightbox close={close}>
        <ContentWrapper
          background={wrapperBackground}
          height={wrapperHeight}
          onClick={e => e.stopPropagation()}
          width={wrapperWidth}
        >
          <ContentContainer background={contentBackground} border={border} height={contentHeight} width={contentWidth}>
            <CloseButton onClick={close}>×</CloseButton>
            {React.createElement(viewComponents[currentViewName], {
              ...this.props,
              onSubmitSuccess
            } as React.Attributes)}
          </ContentContainer>
        </ContentWrapper>
      </Lightbox>
    );
  }
}

class NewsletterLightbox extends React.Component<NewsletterLightboxProps, NewsletterLightboxState> {
  constructor(props) {
    super(props);
    this.state = { currentViewName: viewNames.signUp };
  }

  componentDidMount() {
    const { basePathWeb } = this.props;
    setNewsletterDisplayedSessionCookie(basePathWeb);
  }

  onSubmitSuccess = (): void => {
    this.setState({ currentViewName: viewNames.success });
  };

  render() {
    const { currentViewName } = this.state;
    return (
      <React.Fragment>
        <Desktop>
          <NewsletterLightboxContent
            contentHeight={currentViewName === viewNames.success ? '315px' : '285px'}
            onSubmitSuccess={this.onSubmitSuccess}
            wrapperHeight={currentViewName === viewNames.success ? '335px' : '305px'}
            {...this.props}
            {...this.state}
          />
        </Desktop>
        <Mobile>
          <NewsletterLightboxContent
            border={currentViewName === viewNames.success ? '0px' : null}
            contentBackground={currentViewName === viewNames.success ? 'rgb(238, 238, 238)' : null}
            contentHeight={currentViewName === viewNames.success ? '280px' : '360px'}
            contentWidth={currentViewName === viewNames.success ? '220px' : '300px'}
            onSubmitSuccess={this.onSubmitSuccess}
            wrapperBackground={currentViewName === viewNames.success ? 'rgb(238, 238, 238)' : 'black'}
            wrapperHeight={currentViewName === viewNames.success ? '300px' : '380px'}
            wrapperWidth={currentViewName === viewNames.success ? '240px' : '320px'}
            {...this.props}
            {...this.state}
          />
        </Mobile>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(NewsletterLightbox);
